import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Typography } from '@mui/material';
import STRING_KEYS from '../../../../language/keys';

type AccountsEmptyStateProps = {
  tableColumnsCount: number;
};

const AccountsEmptyState = ({
  tableColumnsCount,
}: AccountsEmptyStateProps): JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <TableRow>
      <TableCell colSpan={ tableColumnsCount } color="secondary">
        <Typography variant="overline" sx={ { color: 'text.secondary' } }>
          {translate(STRING_KEYS.NO_RESULTS)}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default AccountsEmptyState;
